export const breakpoints = {
    xs: 300,
    s: 480,
    m: 768,
    ml: 992,
    l: 1068
}

export const classNames = {
  sticky: {
    stencilSticky: 'stencil-sticky',
    stencilNotSticky: 'stencil-not-sticky',
    hideUnderlying: 'hide-underlying',
    hidden: 'hidden-in-background',
    section: 'sticky',
    sectionCms: 'section-sticky'
  },
  fullVirtualHeight: 'vh-100',
  collapsePadding: {
    top: 'collapse-padding-top',
    bottom: 'collapse-padding-bottom'
  },
  blockMargin: {
    top: 'block-margin-top',
    bottom: 'block-margin-bottom'
  }
}

export const defaultTilesLayoutClass = 'cols-4';

export const customColors = {
  white: '#FFFFFF',
  black: '#000000',
  grey: {
    main: '#AAAAAA',
    veryLight: '#F6F6F6',
    light: '#EBEBEB',
    dark: '#707070',
    darker: '#3C3C3C',
    darkest: '#333333'
  },
  greyBlue: {
    main: '#EBF0F2'
  },
  blue: {
    main: '#0082BE',
    light: '#003C75'
  }
}

export const colorDefs = {
  font: {
    main: customColors.grey.darkest
  },
  background: {
    main: customColors.white,
    light: customColors.grey.light,
    greyAccent: customColors.greyBlue.main
  }
}

export const fontFamilyMain = 'RATIONALSans, sans-serif';
export const fontFamilyIcons = 'raticons, sans-serif';

export const videoIdSelector = '{ID}';

export const urlValueDelimiter = ';';
